/** Display label for export-history `requestedBy` from the API. */
export function requestedByLabel(job) {
  const name = job?.requestedBy?.name
  const email = job?.requestedBy?.email
  if (name && email && name !== email) return `${name} (${email})`
  return name || email || '—'
}
